import type { GuideStep } from './types';

/** Dónde insertar la guía respecto al elemento ancla. Default `after`. */
export type InlinePosition = 'before' | 'after' | 'prepend' | 'append';

export function readInlinePosition(style: GuideStep['style']): InlinePosition {
  const p = (style as Record<string, unknown> | null | undefined)?.inlinePosition;
  return p === 'before' || p === 'prepend' || p === 'append' ? p : 'after';
}

/** Inserta el host en el flujo del DOM relativo al ancla. */
export function insertHost(anchor: Element, host: HTMLElement, position: InlinePosition): void {
  switch (position) {
    case 'before':
      anchor.before(host);
      break;
    case 'after':
      anchor.after(host);
      break;
    case 'prepend':
      anchor.prepend(host);
      break;
    case 'append':
      anchor.append(host);
      break;
  }
}

/**
 * Mantiene el host PEGADO al DOM. Los frameworks del host (React/Next)
 * reconcilian sus contenedores al hidratar/re-renderizar y BORRAN nodos que
 * no reconocen — la guía inline aparecía durante la carga y desaparecía al
 * montar el contenido real. Chequea cada 1s: si el host quedó desconectado,
 * re-busca el ancla y se re-inserta. Devuelve el stop() (registrarlo como
 * cleanup del renderer para que el dismiss/destroy lo corte).
 */
export function keepHostAttached(
  host: HTMLElement,
  selector: string,
  position: InlinePosition,
): () => void {
  const id = window.setInterval(() => {
    if (host.isConnected) return;
    const anchor = document.querySelector(selector);
    if (anchor) insertHost(anchor, host, position);
  }, 1000);
  return () => window.clearInterval(id);
}
